<template>
  <div>
    <div>
      {{date}}
    </div>
    <div v-if="availability.facility">
      {{availability.facility.name}}
    </div>
    <div v-if="location">
      {{location}}
    </div>
    <div v-if="availability.activity">
      {{availability.activity.name}}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    date: {
      type: String,
      required: true
    },
    view: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
  },
  computed: {
    availability: function () {
      return this.event.extendedProps
    },
    location: function () {
      if (!this.availability.facility || (!this.availability.facility.address && !this.availability.facility.address)) {
        return null
      }
      return this.availability.facility.address.city
    }
  }
}
</script>
